export const getHoverYear = ({ navigation }) => navigation.hover_year;
export const getHoverOffset = ({ navigation }) => navigation.hover_offset;
export const getHoverArea = ({ navigation }) => navigation.hover_area;
export const getHoverRegion = ({ navigation }) => navigation.hover_region;
export const getSelectYear = ({ navigation }) => navigation.select_year;
export const getSelectArea = ({ navigation }) => navigation.selected_area;
export const getSelectRegion = ({ navigation }) => navigation.selected_region;
